/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemFinancialsResponseSchema } from './itemFinancialsResponseSchema';

export const itemFinancialsByItemIdsResponseSchema = z.object({
  get data() {
    return z.array(itemFinancialsResponseSchema).describe('Financial data for requested items');
  },
});
